// @ts-check

const noop = () => {}

/**
 * Class representing a message center for handling and dispatching messages.
 * 
 * @callback Create - Creates a message object.
 * @param {string} type - The type of the message.
 * @param {string} path - The path associated with the message.
 * @param {string} message - The message content.
 * @param {any} [payload] - Optional payload associated with the message.
 * @returns {object} The created message object.
 * 
 * @callback Post - Posts a message.
 * @param {string | object} pathOrMessageObj - The path of the message or the message object.
 * 
 * @callback PostSuccess - Posts a success message.
 * @param {string} message - The message content.
 * @param {string} [path='/'] - The path associated with the message.
 * 
 * @callback PostInfo - Posts an info message.
 * @param {string} message - The message content.
 * @param {string} [path='/'] - The path associated with the message.
 * 
 * @callback PostError - Posts an error message.
 * @param {string} message - The message content.
 * @param {string} [path='/'] - The path associated with the message.
 * 
 * @callback PostWarning - Posts a warning message.
 * @param {string} message - The message content.
 * @param {string} [path='/'] - The path associated with the message.
 * 
 * @callback Observe - Observes a specific path and type, and sets a handler for it.
 * @param {string} path - The path to observe.
 * @param {string} type - The type of message to observe.
 * @returns {object} An object with a `by` method to set the handler.
 * 
 * @typedef {Object} MessageCenter
 * @property {Create} create
 * @property {Post} post
 * @property {PostSuccess} postSuccess
 * @property {PostInfo} postInfo
 * @property {PostError} postError
 * @property {PostWarning} postWarning
 * @property {Observe} observe
 */

/**
 * @type MessageCenter
 */
// @ts-ignore
let mc = new Proxy({}, {
    get: (_) =>{
        return noop
    }
})

/**
 * @returns {MessageCenter}
 */
export const useMC = () => mc

/**
 * @param {MessageCenter} _mc
 */
export const setupMC = (_mc) => {
    mc = _mc
}
